import axios from 'axios';
import {
  setPremiumCareList,
  setLoading,
  setExportPremiumCare,
  setExportLoading,
} from '../../../Redux/premiumCare/premiumCareSlice';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

const getAuthHeaders = () => {
  const bearerToken = UserAuthKey();
  return {
    Authorization: `Bearer ${bearerToken}`,
    'Content-Type': 'application/json',
  };
};

const handleAuthError = (error, dispatch) => {
  if (error?.response?.status === 401) {
    dispatch(setUserData(null));
    window.location.replace('/logout');
  }
};

export const fetchPremiumCareList = async ({ params, dispatch }) => {
  dispatch(setLoading(true));
  try {
    const response = await axios({
      method: 'POST',
      url: `${apiUrl}v1/premium-care/list`,
      headers: getAuthHeaders(),
      data: { ...params },
    });
    dispatch(setPremiumCareList(response?.data));
  } catch (error) {
    handleAuthError(error, dispatch);
    dispatch(setPremiumCareList([]));
  }
};

export const fetchExportPremiumCare = async ({ params, dispatch }) => {
  dispatch(setExportLoading(true));
  try {
    const response = await axios({
      method: 'POST',
      url: `${apiUrl}v1/premium-care/export`,
      headers: getAuthHeaders(),
      data: { ...params },
    });
    dispatch(setExportPremiumCare(response?.data));

    return response?.data;
  } catch (error) {
    handleAuthError(error, dispatch);
    const failure = {
      code: 400,
      message: error?.response?.data?.message || 'Export failed',
    };
    dispatch(setExportPremiumCare(failure));

    return failure;
  }
};

export const updatePremiumCare = async ({ params, dispatch }) => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${apiUrl}v1/premium-care/update`,
      headers: getAuthHeaders(),
      data: { ...params },
    });

    return response?.data;
  } catch (error) {
    handleAuthError(error, dispatch);

    return {
      code: 400,
      message: error?.response?.data?.message || 'Update failed',
    };
  }
};
